import { render, staticRenderFns } from "./TransferFund.vue?vue&type=template&id=9e64c3f2&scoped=true&"
import script from "./TransferFund.vue?vue&type=script&lang=js&"
export * from "./TransferFund.vue?vue&type=script&lang=js&"
import style0 from "./TransferFund.vue?vue&type=style&index=0&id=9e64c3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e64c3f2",
  null
  
)

export default component.exports